import React from "react";
import CheckoutStepActions from "./CheckoutStepActions";

interface CheckoutStepLayoutProps {
  title: string;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isProcessing: boolean;
  /** Optional extra content to render before the buttons (e.g. Checkboxes) */
  afterFields?: React.ReactNode;
  children: React.ReactNode;

  nextButtonText: string;
  previousButtonText?: string;

  /** External control to disable the Next/Submit button (e.g. form validation) */
  isNextDisabled?: boolean;
  /** External control to disable the Previous button. Defaults to false. */
  isPrevDisabled?: boolean;

  /** Function to go back. Required if showPrevButton is true and prevButtonType is 'button' */
  onPrevious?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Function to handle next click if not using form submit */
  onNext?: (e: React.MouseEvent<HTMLButtonElement>) => void;

  /** Visibility controls */
  showNextButton?: boolean;
  showPrevButton?: boolean;

  /** Button Types */
  prevButtonType?: "button" | "submit";
  nextButtonType?: "button" | "submit";
}

const CheckoutStepLayout: React.FC<CheckoutStepLayoutProps> = ({
  title,
  onSubmit,
  isProcessing,
  nextButtonText,
  previousButtonText,
  afterFields,
  children,
  isNextDisabled = false,
  isPrevDisabled = false,
  onPrevious,
  onNext,
  showNextButton = true,
  showPrevButton = true,
  prevButtonType = "button",
  nextButtonType = "submit",
}) => {
  return (
    <div className="checkout-step">
      <h2 className="checkout-step__title">{title}</h2>
      <form onSubmit={onSubmit} className="checkout-form">
        {/* Main Form Fields */}
        {children}

        {/* Extra content (like checkboxes) */}
        {afterFields}

        {/* Action Buttons extracted to reusable component */}
        <CheckoutStepActions
          nextButtonText={nextButtonText}
          previousButtonText={previousButtonText}
          isProcessing={isProcessing}
          isNextDisabled={isNextDisabled}
          isPrevDisabled={isPrevDisabled}
          onPrevious={onPrevious}
          onNext={onNext}
          showNextButton={showNextButton}
          showPrevButton={showPrevButton}
          prevButtonType={prevButtonType}
          nextButtonType={nextButtonType}
        />
      </form>
    </div>
  );
};

export default CheckoutStepLayout;
